import React from 'react';

import { Image } from '../Image';
import { LinkButton } from '../LinkButton';
import { Text } from '../Text';
import {
  Body,
  BodyHeader,
  BodyHeaderContent,
  Footer,
  Header,
  HeaderImage,
  HeaderImageWrapper,
  Heading,
  LogoWrapper,
  SubHeading,
  Wrapper,
} from './wrapper';

interface IIAccessoryCardImage {
  src: string;
  srcSet?: string;
  alt: string;
}

interface IIAccessoryCardReadMoreBtn {
  label: string;
  title?: string;
  onClick: () => void;
}

export interface IAccessoryCard {
  image?: IIAccessoryCardImage;
  heading: string;
  price?: string;
  salePrice?: string;
  preamble?: string;
  logo?: IIAccessoryCardImage;
  readMoreBtn?: IIAccessoryCardReadMoreBtn;
}

const AccessoryCard = React.forwardRef<HTMLDivElement, IAccessoryCard>(
  ({ image, heading, price, salePrice, preamble, logo, readMoreBtn }, ref) => (
    <Wrapper ref={ref}>
      {image && (
        <Header>
          <HeaderImageWrapper>
            <HeaderImage src={image.src} srcSet={image.srcSet} alt={image.alt} />
          </HeaderImageWrapper>
        </Header>
      )}
      <BodyHeader>
        <BodyHeaderContent>
          <Heading>{heading}</Heading>
          {price && (
            <SubHeading>
              {salePrice ? (
                <>
                  {salePrice}{' '}
                  <Text as="span" $decoration="line-through" $weight="light">
                    {price}
                  </Text>
                </>
              ) : (
                price
              )}
            </SubHeading>
          )}
        </BodyHeaderContent>
        {logo && (
          <LogoWrapper>
            <Image src={logo.src} srcSet={logo.srcSet} alt={logo.alt} />
          </LogoWrapper>
        )}
      </BodyHeader>
      {preamble && <Body>{preamble}</Body>}
      {readMoreBtn && (
        <Footer>
          <LinkButton
            title={readMoreBtn.title || readMoreBtn.label}
            onClick={readMoreBtn.onClick}
            $hoverGhost
          >
            {readMoreBtn.label}
          </LinkButton>
        </Footer>
      )}
    </Wrapper>
  ),
);

export default AccessoryCard;
